// DrumData.v2.js — Central data module for the app
// Location: src/data/DrumData.v2.js

// ===== WARMUPS =====
export const warmups = [
    {
      id: 'warmup-1',
      title: "5-Minute Beginner Drum Warmup — Emmanuelle Caplette (Drumeo)",
      url: "https://www.youtube.com/watch?v=rS-qVrzHnfY",
      duration: "5 min",
      level: "Beginner",
      description: "Anchor warm-up for long and short sessions",
      lessonType: 'warmup'
    },
    {
      id: 'warmup-2',
      title: "Beginner Routine — Drum Practice (Shorts)",
      url: "https://www.youtube.com/shorts/xOD3nnGulU0?feature=share",
      duration: "~1 min (loop)",
      level: "Beginner",
      description: "Micro warm-up for quick sessions",
      lessonType: 'warmup'
    }
  ];
  
  // ===== GROOVES & SKILLS =====
  export const grooves = [
    {
      id: 'groove-1',
      title: "Rock Beat Fundamentals - Drumeo",
      url: "https://www.youtube.com/watch?v=F8bJzWVKq-k&t=90s",
      duration: "7 min",
      description: "Master the foundation rock groove",
      lessonType: 'groove'
    },
    {
      id: 'groove-2',
      title: "Simple Tom Fills - Rob Brown",
      url: "https://www.youtube.com/watch?v=dBuuzfXs8Ds&t=30s",
      duration: "6 min",
      description: "Connect your grooves with tasteful fills",
      lessonType: 'groove'
    },
    {
      id: 'groove-3',
      title: "Hi-Hat Techniques - Drumeo",
      url: "https://www.youtube.com/watch?v=N2XQjoLw2Kc&t=60s",
      duration: "5 min",
      description: "Open/closed hi-hat control",
      lessonType: 'groove'
    }
  ];
  
  // ===== PRACTICE LESSONS =====
  export const practiceLessons = [
    {
      id: 'practice-1',
      level: 1,
      title: "1-Minute Linear Fill Workout",
      url: "https://www.youtube.com/watch?v=sl9CPVFMbjU",
      duration: "~1 min",
      description: "Basic linear fills using triplets",
      lessonType: 'practice'
    },
    {
      id: 'practice-2',
      level: 2,
      title: "Flam Fill in Less Than a Minute",
      url: "https://www.youtube.com/watch?v=C9QScMyJluk",
      duration: "~1 min",
      description: "Flam control (groups of 5 & 3)",
      lessonType: 'practice'
    },
    {
      id: 'practice-3',
      level: 3,
      title: "Five Fills Every Drummer Uses",
      url: "https://www.youtube.com/watch?v=y1ew3gCLI3w",
      duration: "~1 min",
      description: "Plug-and-play micro fills",
      lessonType: 'practice'
    },
    {
      id: 'practice-4',
      level: 4,
      title: "Two Non-Boring Drum Fills (Drumeo)",
      url: "https://www.youtube.com/watch?v=UNxTSn7NfQw",
      duration: "~3 min",
      description: "Creative rock fills",
      lessonType: 'practice'
    },
    {
      id: 'practice-5',
      level: 5,
      title: "10 Drum Fills Every Drummer Should Know (Stephen Taylor)",
      url: "https://www.youtube.com/watch?v=t1_dO6AI-e0",
      duration: "~7 min",
      description: "Core fill vocabulary",
      lessonType: 'practice'
    },
    {
      id: 'practice-6',
      level: 6,
      title: "5 Powerful & Easy Drum Fills",
      url: "https://www.youtube.com/watch?v=FWKlPDLrdJM",
      duration: "~5 min",
      description: "Rudiments into fills",
      lessonType: 'practice'
    },
    {
      id: 'practice-7',
      level: 7,
      title: "Five Fills That Changed My Life",
      url: "https://www.youtube.com/watch?v=l0kR_1gIxm0",
      duration: "~8 min",
      description: "Conceptual creativity",
      lessonType: 'practice'
    },
    {
      id: 'practice-99',
      level: 99,
      title: "Reward — Chad Smith x 30 Seconds To Mars (Drumeo Feature)",
      url: "https://www.youtube.com/watch?v=HMBRjo33cUE",
      duration: "~12 min",
      description: "Creative listening & improvisation",
      reward: true,
      lessonType: 'practice'
    }
  ];
  
  // ===== SONG PROGRESSION =====
  export const songProgression = [
    {
      id: 'song-1',
      level: 1,
      title: "We Will Rock You - Queen",
      difficulty: "Beginner",
      tutorialUrl: "https://www.youtube.com/watch?v=rMXrTHcY7nM",
      playalongUrl: "https://www.youtube.com/watch?v=2YA0D5VmyXM&list=RD2YA0D5VmyXM&start_radio=1",
      sheetMusic: "https://www.songsterr.com/a/wsa/queen-we-will-rock-you-drum-tab-s16331",
      tempo: "≈ 82 BPM",
      status: "planned"
    },
    {
      id: 'song-2',
      level: 2,
      title: "Wild Thing - The Troggs",
      difficulty: "Beginner",
      tutorialUrl: "https://www.youtube.com/watch?v=eFlhtuQ6y18",
      playalongUrl: "https://www.youtube.com/watch?v=LOZuxwVk7TU",
      sheetMusic: "https://www.songsterr.com/a/wsa/troggs-wild-thing-drum-tab-s384968",
      tempo: "≈ 120 BPM",
      status: "planned",
      hidden: true
    },
    {
      id: 'song-3',
      level: 3,
      title: "Seven Nation Army - The White Stripes",
      difficulty: "Beginner+",
      tutorialUrl: "https://www.youtube.com/watch?v=jUUqia6BdZU",
      playalongUrl: "https://www.youtube.com/watch?v=0J2QdDbelmY",
      sheetMusic: "https://www.songsterr.com/a/wsa/white-stripes-seven-nation-army-drum-tab-s415834",
      tempo: "124 BPM",
      status: "planned",
      hidden: true
    },
    {
      id: 'song-4',
      level: 4,
      title: "Wonderwall - Oasis",
      difficulty: "Beginner+",
      tutorialUrl: "https://www.youtube.com/watch?v=04iNs9uX-LY",
      playalongUrl: "https://www.youtube.com/watch?v=bx1Bh8ZvH84",
      sheetMusic: "https://www.songsterr.com/a/wsa/oasis-wonderwall-drum-tab-s2",
      tempo: "87 BPM",
      status: "planned",
      hidden: true
    },
    {
      id: 'song-5',
      level: 5,
      title: "Boulevard of Broken Dreams - Green Day",
      difficulty: "Beginner+",
      tutorialUrl: "https://www.youtube.com/watch?v=OhwV62p-TpI",
      playalongUrl: "https://www.youtube.com/watch?v=Soa3gO7tL-c",
      sheetMusic: "https://www.songsterr.com/a/wsa/green-day-boulevard-of-broken-dreams-drum-tab-s41516",
      tempo: "≈ 84 BPM",
      status: "planned"
    },
    {
      id: 'song-6',
      level: 6,
      title: "Zombie - The Cranberries",
      difficulty: "Intermediate-",
      tutorialUrl: "https://www.youtube.com/watch?v=hzB4Vn1qW90",
      playalongUrl: "https://www.youtube.com/watch?v=6Ejga4kJUts",
      sheetMusic: "https://www.songsterr.com/a/wsa/cranberries-zombie-accurate-version-drum-tab-s632613",
      tempo: "84 BPM",
      status: "current"
    },
    {
      id: 'song-7',
      level: 7,
      title: "Smells Like Teen Spirit - Nirvana",
      difficulty: "Intermediate",
      tutorialUrl: "https://www.youtube.com/watch?v=q1h1VIQI0G4",
      playalongUrl: "https://www.youtube.com/watch?v=hTWKbfoikeg",
      sheetMusic: "https://www.songsterr.com/a/wsa/nirvana-smells-like-teen-spirit-drum-tab-s18940",
      tempo: "117 BPM",
      status: "planned"
    },
    {
      id: 'song-8',
      level: 8,
      title: "Mr. Brightside - The Killers",
      difficulty: "Intermediate+",
      tutorialUrl: "https://www.youtube.com/watch?v=TrLUOgiqQZE",
      playalongUrl: "https://www.youtube.com/watch?v=gGdGFtwCNBE",
      sheetMusic: "https://www.songsterr.com/a/wsa/killers-mr-brightside-drum-tab-s601",
      tempo: "148 BPM",
      status: "planned"
    },
    {
      id: 'song-9',
      level: 9,
      title: "CHOKE - The Warning",
      difficulty: "Intermediate+",
      tutorialUrl: "https://www.youtube.com/watch?v=3fJlt5l8mt8",
      playalongUrl: "https://www.youtube.com/watch?v=TlOy0XbFVlM",
      sheetMusic: "https://musescore.com/user/60129751/scores/10253074",
      tempo: "≈ 160 BPM",
      status: "planned"
    },
    {
      id: 'song-10',
      level: 10,
      title: "Hell You Call A Dream - The Warning",
      difficulty: "Intermediate+",
      tutorialUrl: "https://www.youtube.com/watch?v=vJLtz9ItNX8",
      playalongUrl: "https://www.youtube.com/watch?v=Q6_hEscMgaQ",
      sheetMusic: "https://www.songsterr.com/a/wsa/warning-hell-you-call-a-dream-drum-tab-s569374",
      tempo: "≈ 156 BPM",
      status: "planned"
    },
    {
      id: 'song-11',
      level: 11,
      title: "23 - The Warning",
      difficulty: "Intermediate (Ballad)",
      tutorialUrl: "https://www.youtube.com/watch?v=YWjhsVdIH2o",
      playalongUrl: "https://www.youtube.com/watch?v=wWW46SudR7Y",
      sheetMusic: "https://www.songsterr.com/a/wsa/warning-23-drum-tab-s521564",
      tempo: "≈ 76 BPM",
      status: "planned"
    },
    {
      id: 'song-12',
      level: 12,
      title: "A Thousand Years - Christina Perri",
      difficulty: "Intermediate (Ballad)",
      tutorialUrl: "https://www.youtube.com/watch?v=3fioJC4HP9o&list=RD3fioJC4HP9o&start_radio=1",
      playalongUrl: "https://www.youtube.com/watch?v=rtOvBOTyX00",
      sheetMusic: "https://www.songsterr.com/a/wsa/christina-perri-a-thousand-years-drum-tab-s413402",
      tempo: "≈ 70 BPM",
      status: "planned"
    },
    {
      id: 'song-13',
      level: 13,
      title: "Love Story - Taylor Swift",
      difficulty: "Intermediate-",
      tutorialUrl: "https://www.youtube.com/watch?v=BCmMw0YJ0H4",
      playalongUrl: "https://www.youtube.com/watch?v=y3zYZgTmhUE&list=RDy3zYZgTmhUE&index=2",
      sheetMusic: "https://www.songsterr.com/a/wsa/taylor-swift-love-story-drum-tab-s29516",
      tempo: "≈ 118 BPM",
      status: "planned"
    },
    {
      id: 'song-14',
      level: 14,
      title: "All Too Well - Taylor Swift",
      difficulty: "Intermediate (Ballad)",
      tutorialUrl: "https://www.youtube.com/watch?v=t8fatIhDdl4&list=RDt8fatIhDdl4&start_radio=1",
      playalongUrl: "https://www.youtube.com/watch?v=9Uo0Awe8Byw",
      sheetMusic: "https://www.songsterr.com/a/wsa/taylor-swift-all-too-well-drum-tab-s516819",
      tempo: "≈ 93 BPM",
      status: "planned"
    },
    {
      id: 'song-15',
      level: 15,
      title: "Toxicity - System Of A Down",
      difficulty: "Advanced-",
      tutorialUrl: "https://www.youtube.com/watch?v=ChPOkpXj5E4",
      playalongUrl: "https://www.youtube.com/watch?v=iywaBOMvYLI",
      sheetMusic: "https://www.songsterr.com/a/wsa/system-of-a-down-toxicity-drum-tab-s40437",
      tempo: "≈ 114-121 BPM (meter changes)",
      status: "planned"
    },
    {
      id: 'song-16',
      level: 16,
      title: "The Kill (Bury Me) - 30 Seconds To Mars [Drumeo/Chad Smith]",
      difficulty: "Intermediate/Advanced",
      tutorialUrl: "https://www.youtube.com/watch?v=HMBRjo33cUE",
      playalongUrl: "https://www.youtube.com/watch?v=8yvGCAvOAfM",
      sheetMusic: "https://www.songsterr.com/a/wsa/30-seconds-to-mars-the-kill-bury-me-drum-tab-s22386",
      tempo: "≈ 92 BPM",
      status: "planned"
    },
    {
      id: 'song-16.1',
      level: 16.1,
      title: "The Kill (Bury Me) - Thirty Seconds to Mars (Original)",
      difficulty: "Intermediate",
      tutorialUrl: "https://www.youtube.com/watch?v=Z5ZiGFKqaLs",
      playalongUrl: "https://www.youtube.com/watch?v=8yvGCAvOAfM",
      sheetMusic: "https://www.songsterr.com/a/wsa/30-seconds-to-mars-the-kill-bury-me-drum-tab-s22386",
      tempo: "≈ 92 BPM",
      status: "planned"
    },
    {
      id: 'song-17',
      level: 17,
      title: "Everlong - Foo Fighters",
      difficulty: "Advanced (Goal)",
      tutorialUrl: "https://www.youtube.com/watch?v=ItZyaOlrb7E",
      playalongUrl: "https://www.youtube.com/watch?v=eBG7P-K-r1Y",
      sheetMusic: "https://www.songsterr.com/a/wsa/foo-fighters-everlong-drum-tab-s51801",
      tempo: "158 BPM",
      status: "goal"
    }
  ];
  
  // ===== HELPER FUNCTIONS =====
  
  /**
   * Get all lessons combined into one array
   */
  export const getAllLessons = () => {
    return [...warmups, ...grooves, ...practiceLessons];
  };
  
  /**
   * Get songs from localStorage or return default progression
   */
  export const getSongs = () => {
    const saved = localStorage.getItem('drumflow_songs');
    return saved ? JSON.parse(saved) : songProgression;
  };
  
  /**
   * Get lessons organized by type from localStorage or defaults
   */
  export const getLessons = () => {
    const saved = localStorage.getItem('drumflow_lessons');
    if (saved) {
      const allLessons = JSON.parse(saved);
      return {
        warmups: allLessons.filter(l => l.lessonType === 'warmup'),
        grooves: allLessons.filter(l => l.lessonType === 'groove'),
        practiceLessons: allLessons.filter(l => l.lessonType === 'practice')
      };
    }
    return { warmups, grooves, practiceLessons };
  };
  
  /**
   * Get only active (non-hidden) songs
   */
  export const getActiveSongs = (songs = getSongs()) => {
    return songs.filter(song => !song.hidden);
  };
  
  /**
   * Get the current song user is learning
   */
  export const getCurrentSong = (songs = getSongs()) => {
    return songs.find(song => song.status === 'current');
  };
  
  /**
   * Get the goal song
   */
  export const getGoalSong = (songs = getSongs()) => {
    return songs.find(song => song.status === 'goal');
  };
  
  /**
   * Get count of completed songs
   */
  export const getCompletedSongsCount = (songs = getSongs()) => {
    return songs.filter(song => song.status === 'completed').length;
  };